import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../locales/en/translation.json";
import translationHK from "../locales/hk/translation.json";
i18n.use(initReactI18next).init({
    resources: {
        // Import translations you made from certain path.
        en: {
            translation: translationEN,
        },
        hk: {
            translation: translationHK,
        },
    },
    lng: "hk",
    fallbackLng: "hk", // Set default language
    debug: true,
    interpolation: {
        escapeValue: false,
    },
});

export const changeLanguage = async (lang?: string) => {
    if (lang) await i18n.changeLanguage(lang);
};

export const locales: { name: string; locale: string; path: string; strapi: string }[] = [
    {
        name: "en",
        locale: "en",
        path: "en",
        strapi: "en",
    },
    {
        name: "hk",
        locale: "hk",
        path: "",
        strapi: "zh-Hant",
    },
];

export default i18n;
